import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { UsersFormDialogComponent } from './users-form-dialog/users-form-dialog.component';

@NgModule({
    declarations: [
        UsersFormDialogComponent
    ],
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [
        UsersFormDialogComponent
    ]
})
export class UsersModule { }
